/* himedi-header-autohide.js — sitewide header that gets out of the way (2026-10-02, Gabe).
 * Why: on phones the fixed header plus the booking page's pinned Checkout bar left a small window
 * for the page itself. Scrolling down hides the header; any scroll up brings it back.
 * Loaded by both headers: sections/himedi-header.liquid and snippets/himedi-checkup-chrome.liquid.
 * It only toggles html.hdr-up; himedi-header-autohide.css does the sliding.
 * The header always shows: within 80px of the top, while the menu drawer is open, while the
 * pointer is over it, and while keyboard focus is inside it. iOS bounce past either end is ignored. */
(function () {
  'use strict';
  var hdr = document.querySelector('header.hdr');
  if (!hdr) return;
  var root = document.documentElement;
  var TOP = 80, DOWN = 12, UP = 6;
  var last = window.scrollY, run = 0, queued = false;

  function show() { root.classList.remove('hdr-up'); }
  function hide() {
    if (hdr.contains(document.activeElement) || hdr.matches(':hover')) return;
    var drawer = document.getElementById('drawer');
    if (drawer && drawer.classList.contains('open')) return;
    root.classList.add('hdr-up');
  }
  function update() {
    queued = false;
    var y = window.scrollY;
    var max = root.scrollHeight - window.innerHeight;
    if (y < 0 || y > max) { last = Math.max(0, Math.min(y, max)); return; }
    var d = y - last;
    last = y;
    if (y <= TOP) { run = 0; show(); return; }
    if (d === 0) return;
    if ((d > 0) !== (run > 0)) run = 0;
    run += d;
    if (run > DOWN) hide();
    else if (run < -UP) show();
  }
  window.addEventListener('scroll', function () {
    if (!queued) { queued = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  hdr.addEventListener('focusin', show);
})();
